if (typeof JW === 'undefined') JW = {};
JW.ViewPort = (function ($)
{
    const _pri = {};
    const publ = {};

    // private
    _pri.vp_map = {xs: [0, 575.999], sm: [576, 767.999], md: [768, 991.999], lg: [992, 1199.999], xl: [1200, 1000000000]};
    // TODO use arr for distinct borders
    _pri.vp_arr = [0, 576, 768, 992, 1200];

    // public
    publ.get = function()
    {
        let w = publ.getWidth();
        let p;
        for (p in _pri.vp_map)
        {
            if (w >= _pri.vp_map[p][0] && w <= _pri.vp_map[p][1])
            {
                return p;
            }
        }
        return '';
    };
    publ.is = function(vp)
    {
        if (!_pri.vp_map.hasOwnProperty(vp))
        {
            return false;
        }
        return (publ.get() === vp);
    };
    publ.isgt = function(vp)
    {
        if (!_pri.vp_map.hasOwnProperty(vp))
        {
            return false;
        }
        return (_pri.vp_map[vp][1] < publ.getWidth());
    };
    publ.islt = function(vp)
    {
        if (!_pri.vp_map.hasOwnProperty(vp))
        {
            return false;
        }
        return (_pri.vp_map[vp][0] > publ.getWidth());
    };
    publ.getWidth = function()
    {
        //return $( window ).width();
        let vw = _pri.getViewport();
        return vw.width;
    };
    publ.getHeight = function()
    {
        //return $( window ).height();
        let vw = _pri.getViewport();
        return vw.height;
    };
    // private
    _pri.getViewport = function()
    {
        let e = window, a = 'inner';
        if (!('innerWidth' in window ))
        {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
    }

    // expose public methods
    return publ;
})(jQuery);